// src/hooks/useActionAreaState.js

import { useState, useEffect } from 'react';

export const useFormState = (actionAreaData, handleActionAreaDataChange, isUnitLeader = true) => {
    const initialFormState = {
        actionarea_title: '',
        description: '',
        tags: [],
        examples: '',
        priority: 'Hoch',
        measure: '',
        ends_at: null,
        fixed_goal: '',
        goal: '',
        result: '',
        status: '',
        comment: '',
        learning1: '',
        learning2: '',
        learning3: '',
    };

    const [formValues, setFormValues] = useState(initialFormState);
    const [isDirty, setIsDirty] = useState(false);

    useEffect(() => {
        if (actionAreaData) {
            setFormValues({
                actionarea_title: actionAreaData.actionarea_title || '',
                description: actionAreaData.description || '',
                tags: actionAreaData.tags || [],
                examples: actionAreaData.examples || '',
                priority: actionAreaData.priority || 'Hoch',
                measure: actionAreaData.measure || '',
                ends_at: actionAreaData.ends_at || '',
                fixed_goal: actionAreaData.fixed_goal || '',
                goal: actionAreaData.goal || '',
                result: actionAreaData.result || '',
                status: actionAreaData.status || '',
                comment: actionAreaData.comment || '',
                learning1: actionAreaData.learning1 || '',
                learning2: actionAreaData.learning2 || '',
                learning3: actionAreaData.learning3 || '',
            });
        }
    }, [actionAreaData]);

    const handleChange = (event) => {
        // Prevent changes if user is not a unit leader
        if (!isUnitLeader) return;
        
        const { name, value } = event.target;

        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: value
        }));

        handleActionAreaDataChange({ [name]: value });
        setIsDirty(true);
    };

    const handleTagChange = (selectedOptions) => {
        // Prevent changes if user is not a unit leader
        if (!isUnitLeader) return;
        
        const tags = selectedOptions ? selectedOptions.map(option => ({
            id: option.id,
            tag_name: option.value
        })) : [];

        setFormValues(prevValues => ({
            ...prevValues,
            tags
        }));

        handleActionAreaDataChange({ tags });
        setIsDirty(true);
    };

    const handleSelect = (selectedValue, field) => {
        // Prevent changes if user is not a unit leader
        if (!isUnitLeader) return;
        
        setFormValues((prevValues) => ({
            ...prevValues,
            [field]: selectedValue
        }));
        handleActionAreaDataChange({ [field]: selectedValue });
        setIsDirty(true);
    };

    const handleTargetSelect = (selectedValue, field) => {
        // Prevent changes if user is not a unit leader
        if (!isUnitLeader) return;
        
        setFormValues((prevValues) => ({
            ...prevValues,
            [field]: selectedValue
        }));
        handleActionAreaDataChange({ [field]: selectedValue });
        setIsDirty(true);
    };

    return {
        formValues,
        setFormValues,
        isDirty,
        setIsDirty,
        handleChange,
        handleTagChange,
        handleSelect,
        handleTargetSelect
    };
};